import React from 'react';
import ReactMarkdown from 'react-markdown';

interface TimelineEntryContentProps {
  content: string;
}

export default function TimelineEntryContent({ content }: TimelineEntryContentProps) {
  return (
    <div className="prose prose-invert max-w-none">
      <ReactMarkdown>{content}</ReactMarkdown>
    </div>
  );
}